export default __webpack_public_path__ + "static/media/badkamer1.9a025ea8.jpg";